export default {
    CheckMobileNumber: (data) => window.axios.post('check_user_details', data),
    //CheckLogin: (data) => window.axios.post('login', data),
    CheckLogin: (data) => window.axios.post('customer_login', data),
    getUserDetails: (data) => window.axios.post('get_user_details_web', data),
    // getVendorSettings: (data) => window.axios.post('get-vendor-settings', data),
    getVendorWebSettings: (data) => window.axios.post('web-settings', data),
    customerChangePassword: (data) => window.axios.post('customer_change_password', data),
    loginGooglefacebook: (data) => window.axios.post('facebook_login', data),
    getLanguageSettings: (data) => window.axios.get('get-language?order_web=' + data),
    getCustomerDetailsMobile: (data) => window.axios.post('customer_details_mobile', data),
    checkMobile: (data) => window.axios.post('check_mobile', data),
    loginOtpVerify: (data) => window.axios.post('login_otp_verify', data),

}